import React from 'react';
import logo from 'assets/images/logo-horizontal.svg';
import successEmail from 'assets/images/success-email.svg';
import failedEmail from 'assets/images/failed-email.svg';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';
import cn from 'classnames';
import DOMPurify from 'dompurify';

function VerifyEmail() {
  const location = useLocation();
  const params = qs.parse(location.search);
  const { confirmation, message } = params;
  const isSuccess = confirmation === 'true';
  return (
    <div className="min-h-full pt-16 pb-12 flex flex-col bg-white">
      <main className="flex-grow flex flex-col justify-center max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex-shrink-0 flex justify-center">
          <img src={logo} className="h-14" alt="App" />
        </div>
        <div className="py-16">
          <div className="text-center">
            <img
              src={isSuccess ? successEmail : failedEmail}
              className="mx-auto"
              alt="App"
            />
            <div className="pt-16">
              <h1
                className={cn(
                  isSuccess ? 'text-gray-900' : 'text-red-700',
                  'text-4xl font-extrabold  tracking-tight sm:text-5xl mb-4'
                )}
              >
                {isSuccess
                  ? 'Account Verified'
                  : DOMPurify.sanitize(message) || 'Link has expired'}
              </h1>
              <p className="text-base text-gray-500">
                {isSuccess
                  ? 'You have successfully verified your email. You may close this window.'
                  : 'You may close this window.'}
              </p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

VerifyEmail.propTypes = {};

export default VerifyEmail;
